import { $user } from 'signals/global.signals';

export const METHODS_WITH_BODY = ['PUT', 'POST', 'PATCH', 'DELETE'];
export const ENVS_WITH_LOG_ENABLE = ['development'];
// eslint-disable-next-line
export const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const REDIRECT_PATHS = {
  investor: '/investor/dashboard',
  founder: '/founder/dashboard',
  dev: '/founder/dashboard',
};

export const mimeToFileTypeMapping = {
  'application/pdf': 'pdf',
  'text/csv': 'csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
};

export const ROLES = {
  1: 'Founder',
  2: 'Co-founder',
  3: 'CEO',
  4: 'CTO',
  5: 'CFO',
  6: 'Managing Partner',
  7: 'General Partner',
  8: 'Partner',
  9: 'Associate',
  10: 'Analyst',
  11: 'Angel',
  12: 'Accounting',
  13: 'Diligence',
};

export const ORGANIZATION_ROLES_OPTIONS = Object.entries(ROLES)
  .map(([id, label]) => ({
    value: parseInt(id, 10),
    label,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const BASE_TODOS = [
  {
    name: `${$user.value.firstName} ${$user.value.lastName}`,
    task: 'Upload Pitch Deck',
    isDone: false,
    userId: $user.value.id,
  },
  {
    name: `${$user.value.firstName} ${$user.value.lastName}`,
    task: 'Upload Financials',
    isDone: false,
    userId: $user.value.id,
  },
  {
    name: `${$user.value.firstName} ${$user.value.lastName}`,
    task: 'Share Deal',
    isDone: false,
    userId: $user.value.id,
  },
];

export const getBaseTodos = () => BASE_TODOS.map((todo) => ({
  ...todo,
  name: `${$user.value.firstName} ${$user.value.lastName}`,
}));

export const STATUS_OPTIONS = [
  { label: 'New', value: 'new', variant: 'primary' },
  { label: 'Follow Up', value: 'followUp', variant: 'secondary' },
  { label: 'In Diligence', value: 'inDiligence', variant: 'warning' },
  { label: 'Offer Made', value: 'offerMade', variant: 'danger' },
  { label: 'Closed', value: 'closed', variant: 'success' },
  { label: 'Passed On', value: 'passedOn', variant: 'info' },
];

export const PIPELINE_STATUS_OPTIONS = [
  {
    id: 0,
    label: 'New',
    value: 'new',
    variant: 'primary',
  },
  {
    id: 1,
    label: 'Pending',
    value: 'pending',
    variant: 'warning',
  },
  {
    id: 2,
    label: 'In Diligence',
    value: 'inDiligence',
    variant: 'secondary',
  },
  {
    id: 3,
    label: 'Offer Made',
    value: 'offerMade',
    variant: 'info',
  },
  {
    id: 4,
    label: 'Follow Up',
    value: 'followUp',
    variant: 'danger',
  },
  {
    id: 5,
    label: 'Closed',
    value: 'closed',
    variant: 'success',
  },
  {
    id: 6,
    label: 'Declined',
    value: 'declined',
    variant: 'dark',
  },
  {
    id: 7,
    label: 'Passed On',
    value: 'passedOn',
    variant: 'dark',
  },
  {
    id: 8,
    label: 'Archived',
    value: 'archived',
    variant: 'dark',
  },
];

export const DEBT_RAISE_TYPES = ['SAFE', 'KISS', 'Convertible Note'];

export const ACQUISITION_TYPES = ['Acquisition', 'Merger'];

export const RATINGS_OPTIONS = [
  { label: 'A+', value: 'A+', variant: 'success' },
  { label: 'A', value: 'A', variant: 'success' },
  { label: 'A-', value: 'A-', variant: 'success' },
  { label: 'B+', value: 'B+', variant: 'warning' },
  { label: 'B', value: 'B', variant: 'warning' },
  { label: 'B-', value: 'B-', variant: 'warning' },
  { label: 'C+', value: 'C+', variant: 'danger' },
  { label: 'C', value: 'C', variant: 'danger' },
  { label: 'C-', value: 'C-', variant: 'danger' },
];
